// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"77445933","411":"9a1d2671","453":"5e560239"}[chunkId] + ".chunk.js";
};